const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
		banner: {},
		classList: []
	},
	methods: {
		// 获取轮播
		getBanner() {
			axios.post(baseURL + 'getIndexImg?mid=60')
				.then(res => {
					if (res.code == 200) {
						this.banner = res.list[0];
					}
				})
				.catch(err => console.log(err));
		},
		// 获取课程
		getClass() {
			axios.post(baseURL + 'getGradeJp?page=1&rows=200')
				.then(res => {
					if (res.code == 200) {
						this.classList = res.list;
					}
				})
				.catch(err => console.log(err));
		},
		goDetail(item) {
			location.href = 'pages/class/detail.html?format=1&type=4&id=' + item.id;
		}
	},
	created() {
		this.getBanner();
		this.getClass();
	}
});